import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ReducedVesselReport, ReportType } from '@navstation-portal/reporting/data-model/vessel-reports';
import { AuthStore } from '@navstation-portal/shared/data-access/auth';
import { ApiErrorMapper, BASE_API_URL } from '@navstation-portal/shared/util/api';

@Injectable({ providedIn: 'root' })
export class VesselReportsService {
  private http = inject(HttpClient);
  private authStore = inject(AuthStore);
  private readonly baseUrl = inject(BASE_API_URL);
  private apiError = inject(ApiErrorMapper).forFeature('VesselReports');

  getVesselReports(vesselId?: string): Observable<ReducedVesselReport[]> {
    if (!this.authStore.isLoggedIn()) {
      return throwError(() => new Error('Not logged in.'));
    }

    if (!vesselId) {
      return throwError(() => new Error('vesselId is required'));
    }

    return this.http.get<ReducedVesselReport[]>(`${this.baseUrl}/${vesselId}/reports`).pipe(
      map((reports) => reports.map(readCanalTransitAsManeuvering)),
      catchError(this.apiError.toApiError('getting vessels'))
    );
  }
}

// TVA-API's list gives a Maneuvering report in a canal the type 'Canal
// Transit'. V1's getReadableReportType shows that report as Maneuvering, and
// ReportType has no Canal Transit member, so the list reads it as Maneuvering.
// The badge, the type sequence and previousReportTypeIn then all see the type
// V1 shows.
const CANAL_TRANSIT = 'Canal Transit';

const readCanalTransitAsManeuvering = (report: ReducedVesselReport): ReducedVesselReport =>
  report.reportType === CANAL_TRANSIT ? { ...report, reportType: ReportType.Maneuvering } : report;
